import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { DenaliFilterContextProvider } from './DenaliFilterContextProvider'
import { useSelectedDenaliScope } from './DenaliScopeProvider'

function getColumnValue (activeScope, scopeMap, defaultValue) {
  const scopeName = activeScope.name
  return scopeName in scopeMap ? scopeMap[scopeName] : defaultValue
}

export function DenaliScopeFilter ({ column, children, scopes }) {
  const { scope, values } = useSelectedDenaliScope()
  const providerValue = useMemo(() => {
    return {
      membershipFilter: (scope && values?.length) ? {
        denaliScope: {
          path: scope.path,
          column: getColumnValue(scope, scopes, column),
          from: values
        }
      } : null
    }
  }, [scope, column, values, scopes])

  return (
    <DenaliFilterContextProvider value={providerValue}>
      {children}
    </DenaliFilterContextProvider>
  )
}

DenaliScopeFilter.propTypes = {
  /** Mapping of what columns should be used for filtering in a denali analysis view based on the current scop */
  scopes: PropTypes.objectOf(PropTypes.string),

  /** default value - says what column should be used for filtering in a Denali Analysis View */
  column: PropTypes.string,

  children: PropTypes.node
}

DenaliScopeFilter.defaultProps = {
  column: 'clientId'
}
